import React, { useState } from 'react';
import { NavLink, useNavigate, Navigate } from 'react-router-dom';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Spinner,
  Image
} from "react-bootstrap";
import { app } from '../../credenciales';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { Toaster } from "sonner";
import { Alert } from "../../utils";
import { getFirestore } from 'firebase/firestore';
import imgLogo from "../../assets/images/ifh-logo.png";
import style from "./PasswordReset.module.css";

const PasswordReset = () => {
  const auth = getAuth(app);

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSetEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      Alert.success(
        "Se ha enviado un email con instrucciones para resetear tu contraseña. Revisa tu casilla de correo"
      );
      setLoading(false);
    } catch (error) {
      if (error.code === "auth/missing-email") {
        Alert.error("Debes escribir un email válido");
      }
      setLoading(false);
    }
  };

  return (
    <Container fluid={true} className={style.loginContainer}>
      <Row className='d-flex justify-content-center text-center mb-4'>
        <Col>
          <Image src={imgLogo} className={style.imgLogo} />
        </Col>
      </Row>
      <Row className='d-flex justify-content-center'>
        <Col className={style.colContainer} md={4} sm={12}>
          <div className='text-center'>
            <h3 className={style.title}>¿Olvidaste tu contraseña?</h3>
            <p className={style.text}>Ingresa tu email a continuación y recibirás instrucciones para resetear tu contraseña</p>
          </div>
          <Form onSubmit={handleSubmit} className="mt-4">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              {/* <Form.Label className={style.formLabels}>Email</Form.Label> */}
              <Form.Control
                isInvalid={
                  email.length > 0 &&
                  !email.match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  )
                }
                type="email"
                placeholder="Email"
                name="email"
                value={email}
                onChange={handleSetEmail}
                className={style.formInputs}
              />
              <Form.Control.Feedback type="invalid">
                {("Debes escribir un correo válido")}
              </Form.Control.Feedback>
            </Form.Group>
            <Button type="submit" className={style.loginBtn}>
              Enviar
              {loading && (
                <Spinner
                  as="span"
                  size="sm"
                  animation="grow"
                  role="status"
                />
              )}
            </Button>
          </Form>
          <div className='text-center mt-4'>
            <NavLink to="/login" className={`${style.register}`}>
              <span className={style.registerSignupTxt}>Volver al login</span>
            </NavLink>
          </div>
          <Toaster richColors position="bottom-center" />
        </Col>
      </Row>
    </Container>
  )

}

export default PasswordReset;